import { api } from "@/lib/apiClient";
import { htmlToPlainText, plainTextToMailHtmlFragment } from "@/lib/mailHtml";

/** Globale Mail-Signatur (HTML), mit Platzhaltern des angemeldeten Nutzers befüllt. */
export async function fetchMailSignatureHtml(): Promise<string> {
  try {
    const data = await api.get<{ preview_html?: string }>("/me/mail-signature");
    return String(data.preview_html || "").trim();
  } catch {
    return "";
  }
}

/** Hängt die Benutzer-Signatur als HTML an. */
export async function appendUserSignatureToHtmlBody(bodyHtml: string): Promise<string> {
  const sig = await fetchMailSignatureHtml();
  if (!sig) return bodyHtml;
  const base = (bodyHtml || "").trim();
  if (base.includes(sig)) return bodyHtml;
  const sigBlock = `<div class="eh-mail-signature">${sig}</div>`;
  return base ? `${base}<br><br>${sigBlock}` : sigBlock;
}

/** Klartext-Signatur (Fallback). */
export async function fetchMailSignaturePlain(): Promise<string> {
  const html = await fetchMailSignatureHtml();
  return htmlToPlainText(html);
}

/** Klartext + Signatur (Legacy/mailto-Fallback). */
export async function appendUserSignatureToPlainBody(body: string): Promise<string> {
  const sig = await fetchMailSignaturePlain();
  if (!sig) return body;
  const base = (body || "").trimEnd();
  if (base.includes(sig)) return body;
  return base ? `${base}\n\n--\n${sig}` : sig;
}

/** Plain-Body → HTML inkl. Signatur. */
export async function plainBodyToSignedMailHtml(plainBody: string): Promise<string> {
  const frag = plainTextToMailHtmlFragment(plainBody);
  return appendUserSignatureToHtmlBody(frag);
}
